import { defineStore} from "pinia";
import { instance } from "./../..";
import { useAdaptCourseStore } from "./../adapt-course";
import { useAdaptChapterStore } from "./../adapt-chapter";
import { getUserFromStorage } from "@/utils/user-store.util";
import { GenericsUtils } from "@/utils/generics.util";
import { ELoader, useAdaptLoaderStore } from "./../adapt-loader";

import {
  getContinueChapterMessage,
  getEndCourseMessage,
  getEndCourseWithoutCertificateMessage,
  getIntroChapterMessage,
  getIntroCourseMessage,
  getIntroObjeciveMessage,
  getIntroQuizMessage,
  getQuizMessage,
} from "./utils";
export enum TypeAlert {
  CONTINUE = "continueChapter",
  INTRO_COURSE = "introCourse",
  INTRO_CHAPTER = "introChapter",
  INTRO_OBJECTIVE = "introObjective",
  QUIZ = "quiz",
  END = "endCourse",
  QUIZ_INIT = "quizInit",
  NO_CERTIFICATE = "noCertificate",
}
interface MessageFields {
  bigTitle: string;
  title: string;
  message: string;
  homeroAvatar: string;
  iconTitle: string;
  buttons: AlertButton[];
}
interface AlertButton {
  name: string;
  action: number | (() => void);
  color: string;
}
type MessageGenerator = () => MessageFields;

const MESSAGE_HANDLERS: Record<TypeAlert, MessageGenerator> = {
  [TypeAlert.INTRO_COURSE]: () => getIntroCourseMessage(),
  [TypeAlert.INTRO_CHAPTER]: () => getIntroChapterMessage(),
  [TypeAlert.CONTINUE]: () => getContinueChapterMessage(),
  [TypeAlert.INTRO_OBJECTIVE]: () => getIntroObjeciveMessage(),
  [TypeAlert.QUIZ]: () => getQuizMessage(),
  [TypeAlert.END]: () => getEndCourseMessage(),
  [TypeAlert.NO_CERTIFICATE]: () => getEndCourseWithoutCertificateMessage(),
  [TypeAlert.QUIZ_INIT]: () => getIntroQuizMessage(),
};

export const store = defineStore({
  id: "adapt-alert",
  state: () => ({
    type: TypeAlert.INTRO_COURSE,
    show: true,
    messageFields: {} as MessageFields,
    data: {
      course: "",
      nameStudent: "",
      chapter: "",
      chapterDescription: "",
    } as any,
    genericUtils: new GenericsUtils(),
  }),
  actions: {
    setCurrentAlert(type: TypeAlert, show: boolean) {
      this.type = type;
      this.setObjectMessage();
      this.show = show;
    },
    hideAlert() {
      this.show = false;
    },
    setType(type) {
      this.type = type;
      this.setObjectMessage();
    },
    closeAlert() {
      this.show = false;
    },
    setObjectMessage() {
      try {
        useAdaptLoaderStore?.start(ELoader.ALERT);

        const messageHandler = MESSAGE_HANDLERS[this.type];
        if (messageHandler) {
          this.messageFields = messageHandler();
        }
      } finally {
        useAdaptLoaderStore?.stop(ELoader.ALERT);
      }
    },
  },
  getters: {
    getCurrentData() {
      return {
        course: useAdaptCourseStore?.course?.name,
        nameStudent: getUserFromStorage()?.firstName,
        chapter: useAdaptChapterStore?.getCurrentChapter()?.name,
        chapterDescription:
          useAdaptChapterStore?.getCurrentChapter()?.description,
      };
    },
    currentMessageField(): MessageFields {
      return this.messageFields;
    },
    showAlert(): boolean {
      return this.show;
    },
  },
});

export const useAlertStore = store(instance);
